<script>
  // packages
  import { intcomma } from 'journalize';

  // local
  import { formatPercent } from '../utils/format.js';

  /** @type {string} */
  export let prompt;
  /** @type {import('../types.d').ReadableCandidate} */
  export let candidate;
  /** @type {import('../types.d').ReadableRace} */
  export let race;
  function slugify(/** @type {string} */ text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }
</script>

<dl class="recall-results-list">
  <dt class="visually-hidden">Voter choice</dt>
  <dd class="choice-label">
    {#if $candidate.is_winner}
      <span class="checkmark {slugify(prompt)}">✓</span>
    {/if}
    {prompt}
  </dd>
  <dt class="visually-hidden">Vote percentage</dt>
  <dd class="vote-percentage">
    {formatPercent($candidate.votes, $race.total_votes)}%
  </dd>
  <dt class="visually-hidden">Total votes</dt>
  <dd class="vote-count">{intcomma($candidate.votes)} votes</dd>
</dl>
